// src/core/online/StatsManager.js

const StatsManager = {
    intervalId: null,

    startPolling: function (targetElement) {
        if (this.intervalId) clearInterval(this.intervalId);

        const updateStats = async () => {
            if (!window.multiplayer || !window.multiplayer.HTTP_URL) return;

            try {
                const response = await fetch(`${window.multiplayer.HTTP_URL}/api/stats`);
                const data = await response.json();

                if (targetElement) {
                    targetElement.innerText = `${data.players} Oyuncu Online`;
                }
            } catch (e) {
                console.warn("Stats polling error:", e);
            }
        };

        // İlk çalıştır
        updateStats();
        // Her 10 saniyede bir güncelle
        this.intervalId = setInterval(updateStats, 10000);
    },

    stopPolling: function () {
        if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
    }
};

window.StatsManager = StatsManager;
